import { css } from 'styled-components';
import { cssBigImage, imageContainerCss } from '../BigImage/BigImage.styles';
import { device } from '../breakpoints';
import { playGrey10 } from '../design-tokens';
import { StyledPlaceHolderItem, StyledRow1, StyledRow2, StyledRow3, StyledRow4 } from './PlaceHolder.styles';

export const getHeroLayout = () => css`
    ${StyledPlaceHolderItem} {
        width: 100%;
        height: 100%;
        background: ${playGrey10};

        margin-bottom: 5px;

        ${StyledRow1} {
            ${imageContainerCss};
            /* animation: none; */
            padding: 0;
            &:after {
                content: '';
                display: block;
                padding: 28.125% 0;
            }
        }

        ${StyledRow2} {
            padding-bottom: 10%;
        }

        ${StyledRow3} {
            display: none;
        }

        ${StyledRow4} {
            display: none;
        }
    }

    @media ${device.GteSmall} {
        ${cssBigImage}

        ${StyledPlaceHolderItem} {
            margin-bottom: 0;

            ${StyledRow2} {
                display: none;
            }
        }
    }
`;
